import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { AccordionComponent } from './accordion.component';

@NgModule({
  declarations: [
    AccordionComponent,
  ],
  imports: [
    // root
    CommonModule,
    IonicModule,
  ],
  exports: [AccordionComponent],
})
export class AccordionModule { }
